import { ReactComponent as EmailIcon } from "assets/images/v2/email-icon.svg";
import NoLOIcon from "assets/images/v2/loan-officer-silhouette.svg";
import { ReactComponent as PhoneIcon } from "assets/images/v2/phone-icon.svg";
import useDesktopChecker from "hooks/useDesktopChecker";
import React, { useState } from "react";
import "./loan-officer-card.scss";
import { LOAN_OFFICER_LABEL, LOAN_OFFICER_CARD_FORMATTED_PHONE_NUMBER, LOAN_OFFICER_CARD_UNFORMATTED_PHONE_NUMBER, LOAN_OFFICER_CALL_QUEUE } from "utilities/Constant";
import { formatPhoneNumber } from "utilities/string";
import { LoanOfficerDetail } from "pages/application/applicationService";

interface LoanOfficerCardProps {
  readonly loInfo?: LoanOfficerDetail;
  readonly hideLabel?: boolean;
}

const isShowDefaultContent = (loInfo?: LoanOfficerDetail) => {
  return loInfo?.name == LOAN_OFFICER_CALL_QUEUE || loInfo?.name == "" || !loInfo || loInfo?.fullName == LOAN_OFFICER_CALL_QUEUE;
}

const noLoContentDefault = (isDesktop: boolean) => (
  <div>
    <h6>Learn about your loan options</h6>
    {isDesktop ? (
      <>
        <span className="paragraph-medium-medium">Call us now!</span>
        <h6>
          <PhoneIcon /> {LOAN_OFFICER_CARD_FORMATTED_PHONE_NUMBER}
        </h6>
      </>
    ) : (
      <a className="lo-card__cta label-large-medium" href={`tel:${LOAN_OFFICER_CARD_UNFORMATTED_PHONE_NUMBER}`}>
        <PhoneIcon /> Call Now
      </a>
    )}
  </div>
);

function LoanOfficerCard({ loInfo, hideLabel }: LoanOfficerCardProps) {
  const isDesktop = useDesktopChecker();
  const [imageLoadError, setImageLoadError] = useState(false);

  let containerClassName = "lo-card__container";
  if (isShowDefaultContent(loInfo)) {
    containerClassName += " lo-card__container--empty";
  }

  return (
    <>
      {!isShowDefaultContent(loInfo) && !hideLabel && (
        <h6 className="heading-regular lo-card__label">
          {LOAN_OFFICER_LABEL}
        </h6>
      )}
      <div className={containerClassName}>
        <div className="lo-card__wrapper">
          {!isShowDefaultContent(loInfo) && (
            <div className="lo-card__image-container">
              {loInfo?.photoImageUrl && !imageLoadError ? (
                <img
                  src={loInfo.photoImageUrl}
                  alt={loInfo.fullName}
                  onError={() => setImageLoadError(true)}
                />
              ) : (
                <div className="lo-card__no-picture">
                  <img src={NoLOIcon} alt="No loan officer" />
                </div>
              )}
            </div>
          )}
          {!isShowDefaultContent(loInfo) ? (
            <div className="lo-card__content">

              <div className="lo-card__lo-text">
                <span className="lo-card__name label-large-regular">{loInfo?.fullName}</span>
                {loInfo?.jobTitle && <span className="lo-card__name label-medium-regular">{loInfo.jobTitle}</span>}
                {loInfo?.nmlsLicenseNumber && (
                  <span className="lo-card__nmls label-medium-regular">{`NMLS #${loInfo.nmlsLicenseNumber}`}</span>
                )}
                {loInfo?.workEmail && (
                  <a href={`mailto:${loInfo.workEmail}`} className={`lo-card__contact label-medium-regular ${isDesktop ? "lo-card__contact--disabled" : ""}`}>
                    <EmailIcon />
                    <span className="lo-card__contact-text label-medium-underlined">{loInfo.workEmail}</span>
                  </a>
                )}
                {loInfo?.phones?.[0]?.number && (
                  <a href={`tel:${loInfo.phones[0].number}`} className={`lo-card__contact label-medium-regular ${isDesktop ? "lo-card__contact--disabled" : ""}`}>
                    <PhoneIcon />
                    <span className="lo-card__contact-text">{formatPhoneNumber(loInfo.phones[0].number)}</span>
                  </a>
                )}
              </div>

            </div>
          ) : (
            <div className="lo-card__empty">
              <div className="lo-card__empty-content">{noLoContentDefault(isDesktop)}</div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default React.memo(LoanOfficerCard);
